module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-5907HD_white-3b49246d3bca17974e38fab944f2e0bc.png";